import { Footer } from '../components/footer';
import { Camp67Header } from '../components/camp67-header/camp67-header';
import { MetaFunction } from '@remix-run/cloudflare';
import { Link } from '@remix-run/react';
import { useMessages } from '../i18n/useMessages';

export const meta: MetaFunction = () => {
  return [
    { title: 'Contact Us - camp67' },
    {
      name: 'description',
      content: "Get in touch with us. We're here to help!",
    },
    {
      tagName: 'link',
      name: 'canonical',
      href: 'https://camp67.com/contact-us',
    },
  ];
};

export default function ContactUsPage() {
  const getMessage = useMessages();
  return (
    <>
      <div className="bg-yellow-50">
        <div className="m-auto bg-white w-full rounded-b-md border-dotted border-b-black border-b pb-7">
          <Camp67Header
            isLogoLight={false}
            isDarkGlowHidden={true}
            textColor="dark"
            isClearBackground
          />
        </div>
        <main className="text-center py-20 px-16">
          <h1 className="text-2xl font-serif">
            {getMessage('camp67-contact.contact-us')}
          </h1>
          <p className="mt-8">
            {getMessage('camp67-contact.offered-by')}{' '}
            <a href="https://www.sukritwellness.com">
              Sukrit Wellness Tours Private Limited
            </a>
            .
          </p>
          <p className="mt-8">
            {getMessage('camp67-contact.address')}: 2nd Floor, 61/62, Pocket C-5, Rohini
            Sector -11, Delhi, North West, Delhi
          </p>
          <p className="mt-2 text-lg">
            {getMessage('camp67-contact.campsite-address')}: Maharshi Sadafal Deo Ashram,
            Sadafal Road, Dewrakh Kachhar, Prayagraj, UP 211019 (
            <Link
              className="text-blue-500 underline"
              to="https://maps.app.goo.gl/yMaLiC9mCLvdcMrJ9"
            >
              see on map
            </Link>
            ).
          </p>
          <p className="mt-8">
            <i>{getMessage('camp67-contact.questions')}</i>
          </p>
          <p className="mt-2">
            {getMessage('camp67-contact.email')}: bookings@camp67.com
          </p>
          <p>{getMessage('camp67-contact.helpdesk')}: 080652 49725</p>
          <p>
            {getMessage('camp67-contact.whatsapp-only')}: +91 84858 35675 / +61 478947432
          </p>
          <p>{getMessage('camp67-contact.outside-india')}: +91 80652 49725</p>
          <br />
          <Link prefetch="intent" to="/terms-of-service" className="underline">
            {getMessage('camp67-contact.see-tos')} &rarr;
          </Link>
        </main>
      </div>
      <Footer isHome={false} />
    </>
  );
}
